var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4.5,
    fill: "#1570EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3737 26.019C22.3332 26.2976 23.3275 26.4385 24.3267 26.4375C25.9336 26.4398 27.5196 26.0734 28.9626 25.3665C29.0053 24.3581 28.7181 23.3634 28.1446 22.533C27.571 21.7026 26.7424 21.0818 25.7843 20.7647C24.8262 20.4476 23.7909 20.4515 22.8352 20.7758C21.8795 21.1001 21.0556 21.7271 20.4883 22.5619M21.3737 26.019V26.0156C21.3737 24.7635 21.0519 23.5856 20.4883 22.5619M21.3737 26.019V26.1382C19.2087 27.4422 16.7283 28.1292 14.2009 28.125C11.5786 28.125 9.1251 27.3994 7.03042 26.1382L7.0293 26.0156C7.02843 24.4231 7.55759 22.8757 8.53335 21.6172C9.50911 20.3587 10.876 19.4607 12.4184 19.0649C13.9609 18.6691 15.5912 18.7979 17.0523 19.4311C18.5135 20.0643 19.7223 21.1657 20.4883 22.5619M17.9988 11.6719C17.9988 12.6789 17.5988 13.6446 16.8867 14.3567C16.1747 15.0687 15.209 15.4687 14.202 15.4687C13.1951 15.4687 12.2294 15.0687 11.5173 14.3567C10.8053 13.6446 10.4053 12.6789 10.4053 11.6719C10.4053 10.6649 10.8053 9.69913 11.5173 8.98708C12.2294 8.27503 13.1951 7.875 14.202 7.875C15.209 7.875 16.1747 8.27503 16.8867 8.98708C17.5988 9.69913 17.9988 10.6649 17.9988 11.6719ZM27.2797 14.2031C27.2797 14.9863 26.9686 15.7375 26.4148 16.2913C25.861 16.8451 25.1099 17.1562 24.3267 17.1562C23.5435 17.1562 22.7924 16.8451 22.2386 16.2913C21.6848 15.7375 21.3737 14.9863 21.3737 14.2031C21.3737 13.4199 21.6848 12.6688 22.2386 12.1149C22.7924 11.5611 23.5435 11.25 24.3267 11.25C25.1099 11.25 25.861 11.5611 26.4148 12.1149C26.9686 12.6688 27.2797 13.4199 27.2797 14.2031Z",
    stroke: "white",
    strokeWidth: 1.68747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/TotalUsers.e234d5749a8a181f737ac7beb7c9e6b8.svg";
export { ForwardRef as ReactComponent };